import { Container, Stack, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolAccordion, PoolAccordionDetails, PoolAccordionItem, PoolAccordionSummary } from '@synergy/components-next';
import { ReactElement } from 'react';

import { ContactInformation } from '../components/contact-information';
import { FooterBottom } from '../components/footer-bottom';
import { FooterNews } from '../components/footer-news';
import { MobileFooterTop } from './components/mobile-footer-top';
import { SocialMedia } from '../components/social-media';
import { footerSelector } from '../../../store/configuration-selectors';
import { useAppSelector } from '../../../../store/store';

const Wrapper = styled(Stack)(({ theme }) => ({
    backgroundColor: theme.palette.common.black,
    color: theme.palette.grey[500],
}));

const StyledPoolAccordion = styled(PoolAccordion)(({ theme }) => ({
    color: theme.palette.grey[500],
    borderColor: theme.palette.grey[500],

    '& .MuiAccordionSummary-content': {
        textTransform: 'uppercase',
    },
}));

export const MobileFooter = (): ReactElement => {
    const footer = useAppSelector(footerSelector);

    const contactItem = footer?.contact && (
        <PoolAccordionItem>
            <PoolAccordionSummary>
                <FormattedMessage id="app.footer.contact.headline" />
            </PoolAccordionSummary>
            <PoolAccordionDetails>
                <ContactInformation contact={footer.contact} />
            </PoolAccordionDetails>
        </PoolAccordionItem>
    );
    const newsItem = footer?.newsLinks && footer.newsLinks.length > 0 && (
        <PoolAccordionItem>
            <PoolAccordionSummary>
                <FormattedMessage id="app.footer.news.headline" />
            </PoolAccordionSummary>
            <PoolAccordionDetails>
                <FooterNews links={footer.newsLinks} />
            </PoolAccordionDetails>
        </PoolAccordionItem>
    );

    const serviceItem = footer?.serviceLinks && footer.serviceLinks.length > 0 && (
        <PoolAccordionItem>
            <PoolAccordionSummary>
                <FormattedMessage id="app.footer.service.headline" />
            </PoolAccordionSummary>
            <PoolAccordionDetails>
                <FooterNews links={footer.serviceLinks} />
            </PoolAccordionDetails>
        </PoolAccordionItem>
    );

    return (
        <Wrapper>
            <MobileFooterTop />
            <Container sx={{ mt: 3 }}>
                <StyledPoolAccordion variant="medium">
                    {contactItem || undefined}
                    {newsItem || undefined}
                    {serviceItem || undefined}
                </StyledPoolAccordion>

                <Stack flexDirection="row" alignItems="center" justifyContent="center" height={154}>
                    {footer?.socialLinks && <SocialMedia links={footer?.socialLinks} />}
                </Stack>
            </Container>
            <FooterBottom links={footer?.bottomLinks || []} />
        </Wrapper>
    );
};
